import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface SidebarPortalProps {
  children: React.ReactNode;
}

export const SidebarPortal: React.FC<SidebarPortalProps> = ({ children }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  const target = document.getElementById('right-sidebar-root');
  if (!target) {
    console.warn('[SidebarPortal] Element "#right-sidebar-root" not found in DOM.');
    return null;
  }

  return createPortal(children, target);
};
